import { QuotesList } from "@/pages/QuoteEditor";

export default function Quotes() {
  return <QuotesList />;
}
